import React from "react"
import * as Fi from "react-icons/fi"
import {FaWhatsapp, FaRegRegistered} from "react-icons/fa"
import { LiaBusinessTimeSolid } from "react-icons/lia";
import { TbDatabasePlus } from "react-icons/tb";
import {VscJson} from "react-icons/vsc"

const Icon = props => {
    let CustomIcon;
    const { iconName, size, color, className } = props;



    const customIcons = [
        'FaWhatsapp',
        'FaRegRegistered',
        'VscJson',
        'LiaBusinessTimeSolid',
        'TbDatabasePlus'
    ]


    if(customIcons.includes(iconName)){
        switch (iconName){
            case 'FaWhatsapp':
                CustomIcon = <FaWhatsapp />
                break;

            case 'FaRegRegistered':
                CustomIcon = <FaRegRegistered />
                break;

            case 'VscJson':
                CustomIcon = <VscJson />
                break;

            case 'LiaBusinessTimeSolid':
                CustomIcon = <LiaBusinessTimeSolid />
                break;

            case 'TbDatabasePlus':
                CustomIcon = <TbDatabasePlus />
                break;
        }
    }



    const icon = CustomIcon ? CustomIcon : React.createElement(Fi[iconName]);
    return <div className={`Icon ${className ? className : ''}`} style={{ fontSize: size, color: color }}>{icon}</div>;
};

export default Icon;